import React, { useMemo, useState } from "react";
import "./FundTransfer.css";
import { toast } from "react-toastify";

const FundTransfer = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];

  // Dynamic Data
  const [funds, setFunds] = useState([
    {
      id: 1,
      amount: "5000",
      ledger: "FD",
      fromBranch: "Bangalore",
      toBranch: "Kolkata",
      date: "2020-02-20",
      status: "Approved",
    },
    {
      id: 2,
      amount: "3000",
      ledger: "RD",
      fromBranch: "Bangalore",
      toBranch: "Kolkata",
      date: "2020-02-20",
      status: "Approved",
    },
  ]);

  // Form State
  const [formData, setFormData] = useState({
    paymentType: "",
    date: "",
    fromBranch: "",
    toBranch: "",
    fromLedger: "",
    toLedger: "",
    amount: "",
    narration: "",
    status: "Approved",
  });

  // Input Handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit Handler
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.paymentType ||
      !formData.date ||
      !formData.fromBranch ||
      !formData.toBranch ||
      !formData.fromLedger ||
      !formData.toLedger ||
      !formData.amount
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    setFunds([...funds, { id: funds.length + 1, ...formData }]);
    toast.success("Record Added Successfully");

    setFormData({
      paymentType: "",
      date: "",
      fromBranch: "",
      toBranch: "",
      fromLedger: "",
      toLedger: "",
      amount: "",
      narration: "",
      status: "Approved",
    });
  };

  // Search + Pagination
  const filteredData = useMemo(() => {
    return funds.filter((item) =>
      Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [funds, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="fund-transfer-container">
        <h1 className="fund-transfer-heading">Fund Transfer</h1>

        {/* ================= FORM ================= */}
        <section className="fund-transfer-top">
          <form className="fund-transfer-form" onSubmit={handleSubmit}>
            <div className="fund-transfer-form-section">

              <div className="fund-transfer-form-input-fields">
                <label>Payment Type</label>
                <select name="paymentType" value={formData.paymentType} onChange={handleChange}>
                  <option value="">Select Payment</option>
                  <option value="Cash">Cash</option>
                  <option value="Bank">Bank</option>
                </select>
              </div>

              <div className="fund-transfer-form-input-fields">
                <label>Date</label>
                <input type="date" name="date" value={formData.date} onChange={handleChange} />
              </div>

              <div className="fund-transfer-form-input-fields">
                <label>From Branch</label>
                <select name="fromBranch" value={formData.fromBranch} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Bangalore">Bangalore</option>
                  <option value="Delhi">Delhi</option>
                </select>
              </div>

              <div className="fund-transfer-form-input-fields">
                <label>To Branch</label>
                <select name="toBranch" value={formData.toBranch} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Kolkata">Kolkata</option>
                  <option value="Mumbai">Mumbai</option>
                </select>
              </div>

              <div className="fund-transfer-form-input-fields">
                <label>From Branch Ledger</label>
                <select name="fromLedger" value={formData.fromLedger} onChange={handleChange}>
                  <option value="">Select Ledger</option>
                  <option value="FD">FD</option>
                  <option value="RD">RD</option>
                </select>
              </div>

              <div className="fund-transfer-form-input-fields">
                <label>To Branch Ledger</label>
                <select name="toLedger" value={formData.toLedger} onChange={handleChange}>
                  <option value="">Select Ledger</option>
                  <option value="FD">FD</option>
                  <option value="RD">RD</option>
                </select>
              </div>

              <div className="fund-transfer-form-input-fields">
                <label>Amount</label>
                <input type="number" name="amount" value={formData.amount} onChange={handleChange} />
              </div>
            </div>

            <div className="fund-transfer-narration-input">
              <label>Narration</label>
              <textarea name="narration" value={formData.narration} onChange={handleChange}></textarea>
            </div>

            <div className="fund-transfer-form-submit-btn">
              <button type="submit">Save</button>
            </div>
          </form>
        </section>

        {/* ================= REPORT SECTION ================= */}
        <div className="fund-transfer-report-container">
           <h1>Fund Transfer Report</h1>
          <div className="fund-transfer-report-filter-div">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="fund-transfer-filter">
              <label>Show </label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
              <span> entries</span>
            </div>
          </div>

          <div className="fund-transfer-report-table-container">
           
            <table className="fund-transfer-report-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Amount</th>
                  <th>Ledger</th>
                  <th>From Branch</th>
                  <th>To Branch</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item.amount}</td>
                      <td>{item.ledger}</td>
                      <td>{item.fromBranch}</td>
                      <td>{item.toBranch}</td>
                      <td>{item.date}</td>
                      <td>{item.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filteredData.length > itemsPerPage && (
            <div className="fund-transfer-pagination-div">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                ⬅ Prev
              </button>

              <span> Page {currentPage} of {totalPages} </span>

              <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                Next ➡
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FundTransfer;
